// extracted by mini-css-extract-plugin
module.exports = {"container-hyperlink":"nY59gCJhwSz5Ems0uqPo3","checkout-setting-link":"sTfyQig1jb5gHKU64-ZZ8"};